exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1HzDhXErSwdC9-EzTRYHFr{display:inline-block}html[dir=ltr] ._1HzDhXErSwdC9-EzTRYHFr{padding-right:10px}html[dir=rtl] ._1HzDhXErSwdC9-EzTRYHFr{padding-left:10px}", ""]);
// Exports
exports.locals = {
	"spinner": "_1HzDhXErSwdC9-EzTRYHFr"
};